var map = {
	"./sinon": 302,
	"./sinon.js": 302,
	"./sinon/assert": 305,
	"./sinon/assert.js": 305,
	"./sinon/behavior": 307,
	"./sinon/behavior.js": 307,
	"./sinon/call": 308,
	"./sinon/call.js": 308,
	"./sinon/collection": 309,
	"./sinon/collection.js": 309,
	"./sinon/extend": 310,
	"./sinon/extend.js": 310,
	"./sinon/format": 311,
	"./sinon/format.js": 311,
	"./sinon/log_error": 316,
	"./sinon/log_error.js": 316,
	"./sinon/match": 317,
	"./sinon/match.js": 317,
	"./sinon/mock": 318,
	"./sinon/mock.js": 318,
	"./sinon/sandbox": 319,
	"./sinon/sandbox.js": 319,
	"./sinon/spy": 320,
	"./sinon/spy.js": 320,
	"./sinon/stub": 321,
	"./sinon/stub.js": 321,
	"./sinon/test": 322,
	"./sinon/test.js": 322,
	"./sinon/test_case": 323,
	"./sinon/test_case.js": 323,
	"./sinon/times_in_words": 324,
	"./sinon/times_in_words.js": 324,
	"./sinon/typeOf": 325,
	"./sinon/typeOf.js": 325,
	"./sinon/util/core": 326,
	"./sinon/util/core.js": 326,
	"./sinon/util/event": 328,
	"./sinon/util/event.js": 328,
	"./sinon/util/fake_server": 329,
	"./sinon/util/fake_server.js": 329,
	"./sinon/util/fake_server_with_clock": 330,
	"./sinon/util/fake_server_with_clock.js": 330,
	"./sinon/util/fake_timers": 331,
	"./sinon/util/fake_timers.js": 331,
	"./sinon/util/fake_xdomain_request": 333,
	"./sinon/util/fake_xdomain_request.js": 333,
	"./sinon/util/fake_xml_http_request": 334,
	"./sinon/util/fake_xml_http_request.js": 334,
	"./sinon/util/timers_ie": 335,
	"./sinon/util/timers_ie.js": 335,
	"./sinon/util/xdr_ie": 336,
	"./sinon/util/xdr_ie.js": 336,
	"./sinon/util/xhr_ie": 337,
	"./sinon/util/xhr_ie.js": 337,
	"./sinon/walk": 338,
	"./sinon/walk.js": 338
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib ^\.\/.*$
// module id = 304
// module chunks = 1